/* eslint-disable react/prop-types */
import React from "react";
import Home from "../components/Home";

export default function Homepage() {
  return <Home />;
}
